import { object, string, number, array } from "yup";
import { TFunction } from "i18n";
import { Message } from "yup/lib/types";
import { NON_BINARY_FACET_ID } from "../../../../hooks/useAdditionalGenderOptions";
import { IAboutYouFormPhotoModel } from "../../../../formModels/AboutYouFormModel";
import { IGraduatesApplication } from "../types";
import {
  DetailsPageFormFields,
  DetailsPageHeadshotFormFields,
  IGraduatesDetailsFormFields,
} from "./constants";

export const INPUT_FIELDS_MAX_LENGTH = 75;

export const headshotFormInitialValues: IAboutYouFormPhotoModel = {
  [DetailsPageHeadshotFormFields.Photo]: [],
  [DetailsPageHeadshotFormFields.PhotographerName]: "",
};

export const formInitialValues = {
  [DetailsPageFormFields.Agent]: null,
  [DetailsPageFormFields.Gender]: null,
  [DetailsPageFormFields.GenderNonBinaryCustom]: "",
  [DetailsPageFormFields.GenderFurtherInfo]: "",
  [DetailsPageFormFields.DisplayGender]: false,
  [DetailsPageFormFields.Location]: [],
};

export function getInitialValues(
  graduatesApp?: IGraduatesApplication
): IGraduatesDetailsFormFields {
  if (!graduatesApp)
    return { ...formInitialValues, ...headshotFormInitialValues };

  return {
    [DetailsPageFormFields.Agent]: graduatesApp.agencyRefNumber || null,
    [DetailsPageFormFields.Gender]: graduatesApp.findMeAs,
    [DetailsPageFormFields.GenderNonBinaryCustom]:
      graduatesApp.customOrNonBinaryGender || null,
    [DetailsPageFormFields.GenderFurtherInfo]:
      graduatesApp.genderFurtherInformation || "",
    [DetailsPageFormFields.DisplayGender]:
      graduatesApp.showGenderOnProfile === "yes",
    [DetailsPageFormFields.Location]:
      graduatesApp.locationIds?.map((locationId) => {
        return {
          id: locationId,
          name: "", // placeholder. Not relevant at present as we're not backfilling this data yet. Nice to have feature.
        };
      }) || [],
  };
}

export function getDetailsPageValidation(t: TFunction) {
  return object().shape({
    [DetailsPageFormFields.Agent]: number().nullable().optional(),
    [DetailsPageFormFields.Gender]: number().required(
      t("common:validation.error.entryRequired", {
        fieldName: t("common:label.gender"),
      }) as Message<{}>
    ),
    [DetailsPageFormFields.GenderNonBinaryCustom]: string()
      .nullable()
      .when(DetailsPageFormFields.Gender, {
        is: (value: number) => value === NON_BINARY_FACET_ID,
        then: string().required(
          t("common:validation.error.entryRequired", {
            fieldName: t("common:label.field"),
          }) as Message<{}>
        ),
      }),
    [DetailsPageFormFields.GenderFurtherInfo]: string()
      .optional()
      .max(INPUT_FIELDS_MAX_LENGTH),
    [DetailsPageFormFields.DisplayGender]: string().required(
      t("common:validation.error.entryRequired", {
        fieldName: t("common:label.field"),
      }) as Message<{}>
    ),
    [DetailsPageFormFields.Location]: array()
      .of(
        object().shape({
          id: string(),
          name: string(),
        })
      )
      .required(
        t("common:validation.error.entryRequired", {
          fieldName: "Location",
        }) as Message<{}>
      )
      .min(1, t("common:performer.profile.location.listValidation")),
  });
}
